export const categories = [
  { slug: "movie", name: "电影", icon: "ri-movie-2-line", count: 128 },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line", count: 96 },
  { slug: "variety", name: "综艺", icon: "ri-emotion-laugh-line", count: 84 },
  { slug: "anime", name: "动漫", icon: "ri-ghost-line", count: 72 },
  { slug: "documentary", name: "纪录片", icon: "ri-film-line", count: 56 },
  { slug: "music", name: "音乐", icon: "ri-music-line", count: 64 },
  { slug: "sports", name: "体育", icon: "ri-basketball-line", count: 48 },
  { slug: "game", name: "游戏", icon: "ri-gamepad-line", count: 92 },
];